"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseeType = void 0;
var LicenseeType;
(function (LicenseeType) {
    LicenseeType["INDIVIDUAL"] = "INDIVIDUAL";
    LicenseeType["COMPANY"] = "COMPANY";
})(LicenseeType || (exports.LicenseeType = LicenseeType = {}));
